import axios from "axios";
import { Loading } from "features/common";
import { apiUrl } from "features/configure";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import React, { useEffect, useMemo, useState } from "react";
import { useOutletContext, useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import Back from "../components/Back";
import { Box } from "@mui/material";
import XFeed from "./components/XFeed";
import KeywordAnalysisChart from "./components/KeywordAnalysisChart";
import useNavigateEntity from "hooks/useNavigateEntity";
import { useIntl } from "react-intl";
import Button from "@metacrm/metacrm-material-ui/dist/Button";
import { StyledSkeleton } from "components/LoadingComponent/LoadingComponent.styles";
import AutoCompleteDropdown from "@metacrm/metacrm-material-ui/dist/AutoCompleteDropdown";
import { useTheme } from "@mui/material";
import KolTable from "features/metadesk/Kol/components/KolTable";

export default function KeywordAnalysis() {
  const theme = useTheme();
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectedKolGroup, setSelectedKolGroup] = useState({
    _id: null,
    value: "all",
    label: "All",
  });
  const [entityName] = useOutletContext();
  const { keywordId } = useParams();
  const [searchParams] = useSearchParams();
  const keyword = searchParams.get("keyword");
  const { navigateEntity } = useNavigateEntity();
  const dispatchSnackbar = useDispatchSnackbar();
  const { formatMessage } = useIntl();

  // tmp mock data
  const kolGroupsData = [
    {
      _id: null,
      value: "all",
      label: "All",
    },
    {
      _id: "5f95d9d5",
      value: "5f95d9d5",
      label: "KOL Group 1",
      kols: [
        "5f95d9d5",
        "5f95d9d6",
        "5f95d9d7",
        "5f95d9d8",
        "5f95d9d9",
        "5f95d9da",
      ],
    },
    {
      _id: "5f95d9d6",
      value: "5f95d9d6",
      label: "KOL Group 2",
      kols: ["5f95d9d6", "5f95d9d7"],
    },
    {
      _id: "5f95d9d7",
      value: "5f95d9d7",
      label: "KOL Group 3",
      kols: ["5f95d9d7", "5f95d9d8"],
    },
  ];

  const getKeywordAnalysisData = async () => {
    try {
      setIsLoading(true);
      // const { data } = await axios(
      //   `${apiUrl}/api/kol/${entityName}/keyword/${keywordId}/detail`
      // );

      const data = {};

      setData(data);
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getKeywordAnalysisData();
  }, []);

  const { posts = [] } = data;

  const postLinks = useMemo(() => {
    // const all = {
    //   label: "All",
    //   value: "",
    // };

    if (!data?.posts) return [];
    const getShortLink = (link) => {
      const firstIndex = link.indexOf("/");
      const secondIndex = link.indexOf("/", firstIndex + 1);
      const questionIndex = link.indexOf("?");
      const index = secondIndex === -1 ? questionIndex : secondIndex;
      return link.slice(0, index + 1) + "..." + link.slice(-5);
    };

    return [
      // all,
      ...data.posts.map((post) => ({
        label: getShortLink(post.postLink),
        value: post.postLink,
      })),
    ];
  }, [data.posts]);

  return (
    <div className="fade-up">
      <Back noMt />
      <Box sx={{ marginBottom: "30px" }}>
        <div className="title">
          {formatMessage(
            { id: "global.keywordAnalysis.title" },
            { keyword: keyword }
          )}
        </div>
        <div className="description">
          {formatMessage({ id: "global.keywordAnalysis.subtitle" })}
        </div>
      </Box>
      <Box sx={{ width: "360px" }}>
        <AutoCompleteDropdown
          size="large"
          value={kolGroupsData.find(
            (option) => option.value === selectedKolGroup.value
          )}
          options={kolGroupsData}
          onChange={(event, newValue) => {
            setSelectedKolGroup(newValue);
          }}
          customNodeInOption={
            <Box paddingLeft="16px" mb="8px">
              <Box
                color={(theme) => theme.customColors.grey[600]}
                sx={{ fontSize: "12px", fontWeight: 600 }}
              >
                {formatMessage({
                  id: "dropdown.instruction.createKolGroup",
                })}
              </Box>
            </Box>
          }
        />
      </Box>
      <Box
        sx={{
          backgroundColor: theme.customColors.grey[300],
          height: "1px",
          margin: "12px 0",
        }}
      />
      <Box display="flex" justifyContent="space-between" position="relative">
        <Box
          sx={{
            maxWidth: "calc(100% - 287px)",
            "@media (max-width: 768px)": {
              maxWidth: "100%",
            },
            flex: 1,
            paddingRight: "20px",
            marginBottom: "20px",
          }}
        >
          <KeywordAnalysisChart />
          <Box sx={{ marginTop: "32px" }}>
            {formatMessage({ id: "keyword.kollist.title" })}
            <KolTable
              groupData={{ groupId: selectedKolGroup._id }}
              showControls={{
                filter: false,
                search: false,
              }}
            />
          </Box>
        </Box>
        <XFeed />
      </Box>
    </div>
  );
}
